import { Injectable } from '@angular/core';

import { Constants } from './constants.util';
import { UserPermissions } from '../models/user-permissions.model';

@Injectable()
export class RouteUtil {
    static checkPage(userPermissions: UserPermissions, page: string): boolean {
        if (!userPermissions) {
            return false;
        }

        return this.isPageViewable(userPermissions, page);
    }

    static findPageRoute(userProfile: UserPermissions, page: string): string {
        let route = "";
        let pages = Constants.Pages;

        for(let counter = 0; counter < pages.length; counter++) {
            let arrayPage = pages[counter][0];

            if (this.checkPage(userProfile, arrayPage)) {
                if ((page == undefined || page == null || page == "") || (page.toLowerCase() == arrayPage.toLowerCase())) {
                    route = pages[counter][1];
                    break;
                }
            }
        }

        return route;
    }

    static getPageByRoute(route: string): string {
        let pageName = '';

        Constants.Pages.forEach(page => {
            if (route.includes(page[1])) {                
                pageName = page[0];
            }
        });

        return pageName;
    }  
    
    static getRouteByPage(page: string): string {
        let results = Constants.Pages.filter(p => p[0] == page);

        if (!results || !results.length || results.length < 1) {
            return '';
        }

        let result = results[0];

        if (!result || !result.length || result.length < 2) {
            return '';
        }

        return results[0][1];
    }

    static isClientImpersonated() : boolean {
        let hacid = sessionStorage.getItem(Constants.HuronAdminClientId);

        return this.isHuronAdmin() && hacid && parseInt(hacid,10) > 1
    }
    
    static isHuronAdmin(): boolean {     
        let readPermissionAreas = sessionStorage.getItem(Constants.ReadPermissionAreaName);
        return this.isPermissionAreaAvailable(readPermissionAreas, Constants.ClientImpersonation)
    }

    static isPermissionAreaAvailable(permissionAreas: string, page: string) : boolean {
        if (!permissionAreas) {
            return false;
        }

        let areas = permissionAreas.toLowerCase().split(',');
        return areas.indexOf(page.toLowerCase()) >= 0;
    }
    
    static isPageViewable(userPermissions: UserPermissions, page: string): boolean {
        if (!userPermissions) { 
            return false; 
        }
        
        return this.isPermissionAreaAvailable(userPermissions.readPermissionAreas, page);
    }    
}